import {
  NEW_ENTRY_SOURCE,
  COMPETITORS_SOURCE,
  MY_PRODUCTS_SOURCE
} from 'constants/rank_tracker_v2'
import isEmpty from 'lodash/isEmpty'

const getEmptyProductUIConfiguration = () => {
  const newAsinProductSource = {
    productName: null,
    productImageUrl: null,
    hasValidationError: false,
    errorMessage: null,
    isValidAsin: false,
    isValidationPending: false
  }

  const productPreviews = {
    isLoading: false,
    products: []
  }

  return {
    newAsinProductSource,
    productPreviews
  }
}

const getEmptyProductDataConfiguration = () => {
  const mwsProductSource = {
    countryCode: null,
    selectedProducts: [],
    products: []
  }

  const newAsinProductSource = {
    countryCode: 'us',
    asin: ''
  }

  const competitorAsins = []
  const selectedKeywordLists = []

  const removedKeywords = []
  const productSource = NEW_ENTRY_SOURCE
  const keywordsSource = COMPETITORS_SOURCE
  const product = null
  const annotations = []

  return {
    product,
    productSource,
    keywordsSource,
    mwsProductSource,
    newAsinProductSource,
    competitorAsins,
    selectedKeywordLists,
    removedKeywords,
    annotations
  }
}

const getNewProductDataState = (state, product) => {
  const { rank_tracker_settings: settings } = product

  const removedKeywords = settings?.keyword_bank?.manually_removed || []

  if (isEmpty(settings)) {
    return {
      ...getEmptyProductDataConfiguration(),
      product,
      productSource: NEW_ENTRY_SOURCE,
      removedKeywords,
      newAsinProductSource: {
        countryCode: product.country,
        asin: product.asin
      }
    }
  }

  const productSource = settings.product.source
  const keywordsSource = settings.keywords.source
  let productSourceData

  if (productSource === MY_PRODUCTS_SOURCE) {
    productSourceData = {
      mwsProductSource: {
        ...state.data.mwsProductSource,
        countryCode: product.country
      }
    }
  } else {
    productSourceData = {
      newAsinProductSource: {
        countryCode: product.country,
        asin: product.asin
      }
    }
  }

  const competitorAsins = []
  const selectedKeywordLists = settings.keywords.keyword_list_ids.map(id => {
    return { id }
  })

  return {
    ...getEmptyProductDataConfiguration(),
    product,
    ...productSourceData,
    productSource,
    keywordsSource,
    competitorAsins,
    selectedKeywordLists,
    removedKeywords
  }
}

const getNewProductUIState = newProductDataState => {
  const { product, productSource } = newProductDataState

  if (productSource !== NEW_ENTRY_SOURCE) {
    return getEmptyProductUIConfiguration()
  }

  return {
    newAsinProductSource: {
      productName: product.name,
      productImageUrl: product.imageUrl,
      hasValidationError: false,
      errorMessage: null,
      isValidAsin: true,
      isValidationPending: false
    },
    productPreviews: {
      isLoading: false,
      products: []
    }
  }
}

export const mergeWithExistingProductConfiguration = (state, product) => {
  const productSourceSelectedCountryCode = product.country
  const productSourceSelectedAsins = [product.asin]
  const newProductDataState = getNewProductDataState(state, product)
  const newProductUIState = getNewProductUIState(newProductDataState)

  return {
    ...state,
    data: {
      ...state.data,
      productSourceSelectedCountryCode,
      productSourceSelectedAsins,
      ...newProductDataState
    },
    ui: {
      ...state.ui,
      ...newProductUIState
    }
  }
}

export const mergeWithCleanProductConfiguration = state => {
  const productSourceSelectedCountryCode = null
  const productSourceSelectedAsins = []
  const rankKeywords = []
  const keywordBank = []

  return {
    ...state,
    data: {
      ...state.data,
      productSourceSelectedCountryCode,
      productSourceSelectedAsins,
      rankKeywords,
      keywordBank,
      ...getEmptyProductDataConfiguration()
    },
    ui: {
      ...state.ui,
      ...getEmptyProductUIConfiguration()
    }
  }
}
